import styled from 'styled-components';
import ArrowLeftIon from '../../../assets/svg/arrow_left_ion.svg';

export const FixedHeaderSection = () => {
  return (
    <Container>
      <BackButtonContainer>
        <Button
          type={'button'}
          onClick={() => {
            window.location.href = 'https://market.pluva.kr/home';
          }}
        >
          <img src={ArrowLeftIon} alt="뒤로가기" width={24} height={24} />
        </Button>
      </BackButtonContainer>
      <HeaderTitle>{'플루바 아이온'}</HeaderTitle>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  max-width: 512px;
  height: 48px;

  margin: 0 auto;
  padding: 0 16px;

  position: fixed;
  top: 0px;
  z-index: 100;

  background-color: #0d0d0d;
`;

const BackButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;

  padding-right: 16px;
`;

const Button = styled.button`
  height: 24px;
`;

const HeaderTitle = styled.span`
  color: #858894;
  text-align: center;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */

  overflow: hidden;
  text-overflow: ellipsis;

  display: block;
  white-space: nowrap;
`;
